<div class="no-content" *ngIf="notifications.length === 0">
  {{noNotificationFoundLabel}}
</div>

<div class="scroll-container">
    @for (notification of notifications; track notification.id) {
      <div class="grid notification-card col-nopad">
        <div class="grid col-12 notification-time">
          <div class="col-6 date col-nopad">
            {{ notification.createdAt | dateformat }}
          </div>
          <div class="col-6 ago col-nopad">
            {{ notification.createdAt | ago }}
          </div>

          <div class="col-12 message">
            {{ notification.message }}
          </div>
        </div>
      </div>
    } 
    @empty {
      <div class="text-center text-xl py-8 text-gray-500">
        No Data Available.
      </div>
    }
  <div class="col-12" *ngIf="notifications.length > 0">
    <button pButton class="assign-btn load-more-btn" type="button" [label]="labelLoadMore" (click)="onLoadMore()"></button>
  </div>

</div>